
import {
    GET_PAR_HISTORY_ACTION_TYPE,
} from '../sagas/parHistory';

import { createLoaderReducer } from '../common/client/reducers/loader';

export function getData(state) {
    return state.data?.result?.result;
}

export function isLoading(state) {
    return state.loading;
}

export default function createReducer() {
    return createLoaderReducer(GET_PAR_HISTORY_ACTION_TYPE);
}
